import axios from 'axios';

export const getInvoice = async ({ headers, transactionId }) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_INVOICE_BASE_URL}/${transactionId}`,
      { headers }
    );

    const invoice = response.data;

    return invoice;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};
